// extracted by mini-css-extract-plugin
export default {"arrowDownIcon":"ArrowDownIcon_arrowDownIcon__ppBqb"};